module.exports = __webpack_public_path__ + "static/media/loanAppBorrowerWhite.fd6231ab.svg";